// 引用 Compressor
import Compressor from 'compressorjs';
/** 工具类 **/
// 图片http开头
const withHttpStart = function (str) {
    if (str.indexOf("http") == 0) {
        return true;
    } else {
        return false;
    }
};
// 匹配手机号,中间四位隐藏
const formatPhone = function (iphone) {
    let reg = /^(\d{3})\d*(\d{4})$/;
    if (reg.test(iphone)) {
        return iphone.replace(reg, "$1****$2");
    } else {
        return iphone;
    }
};
// 距离某个时间点的差  xx天
const intervalTime = function (currentTimsmap, endTime) {
    let subTime = endTime - currentTimsmap;
    if (subTime > 0) {
        // 相差的天数
        var days = Math.floor(subTime / (24 * 3600 * 1000));
        return days + "天";
    } else {
        return false;
    }
};
// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15'
const getTimes = function (strdate) {
    let arr = strdate.split(/[- : \/]/);
    let date = new Date(arr[0], arr[1] - 1, arr[2], 24, 0, 0);
    return date;
};
// 某天时间 传入Date
const getDateFun = function (date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    let obj = {
        year: formatNumber(year),
        month: formatNumber(month),
        day: formatNumber(day),
        date: `${[year, month, day].map(formatNumber).join("-")}`,
        daytime: `${[year, month, day].map(formatNumber).join("-")} ${[
            hour,
            minute,
            second,
        ]
            .map(formatNumber)
            .join(":")}`,
    };
    // 返回年月日
    return obj;
};
const formatNumber = (n) => {
    n = n.toString();
    return n[1] ? n : `0${n}`;
};
// 周几 2022-10-24
const formatWeekDay = function (str) {
    let day = new Date(str).getDay();
    let week = "";
    switch (day) {
        case 0:
            week = "星期日";
            break;
        case 1:
            week = "星期一";
            break;
        case 2:
            week = "星期二";
            break;
        case 3:
            week = "星期三";
            break;
        case 4:
            week = "星期四";
            break;
        case 5:
            week = "星期五";
            break;
        case 6:
            week = "星期六";
            break;
    }
    return week;
};
const getUrlParams = function (url) {
    let theRequest = new Object();
    if (url.indexOf('?') != -1) {
        let index = url.indexOf('?');
        let params = url.slice(index + 1, url.length);
        let paramsArr = params.split('&');
        for (let i = 0; i < paramsArr.length; i++) {
            theRequest[paramsArr[i].split("=")[0]] = paramsArr[i].split("=")[1];
        }
    };
    return theRequest;
};
/**
 * @name: 图片压缩
 * @param {*} file
 * @param {*} backType
 * @return {*}
 * @desc: 
 */
const imageCompressor = function (file, backType) {
    let quality = 0.8;
    return new Promise(((resolve, reject) => {
        new Compressor(file, {
            quality: quality, //压缩质量
            success (result) {
                // console.log('backType',backType)
                // 当文件过大时，会被转成blob类型；接口不支持，需将blob转file
                if (isBlob(result)) {
                    result = new File([result], file.name, { type: file.type, lastModified: Date.now() });;
                };
                if (!backType || backType == 'blob') {
                    resolve(result);
                } else if (backType == 'file') {
                    resolve(result);
                } else {
                    resolve(result);
                }
            },
            error (err) {
                console.log("图片压缩失败");
                reject(err);
            }
        })
    }))
};
const isBlob = function (val) {
    return toString.call(val) == '[object Blob]';
};
export default {
    withHttpStart,
    formatPhone,
    intervalTime,
    getTimes,
    getDateFun,
    formatWeekDay,
    getUrlParams,
    imageCompressor,
    isBlob
};
